var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaintenance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z",
    stroke: "#00A79D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66667 10.7329V9.26621C1.66667 8.39954 2.375 7.68287 3.25 7.68287C4.75833 7.68287 5.375 6.61621 4.61667 5.30787C4.18333 4.55787 4.44167 3.58287 5.2 3.14954L6.64167 2.32454C7.3 1.93287 8.15 2.16621 8.54167 2.82454L8.63333 2.98287C9.38333 4.29121 10.6167 4.29121 11.375 2.98287L11.4667 2.82454C11.8583 2.16621 12.7083 1.93287 13.3667 2.32454L14.8083 3.14954C15.5667 3.58287 15.825 4.55787 15.3917 5.30787C14.6333 6.61621 15.25 7.68287 16.7583 7.68287C17.625 7.68287 18.3417 8.39121 18.3417 9.26621V10.7329C18.3417 11.5995 17.6333 12.3162 16.7583 12.3162C15.25 12.3162 14.6333 13.3829 15.3917 14.6912C15.825 15.4495 15.5667 16.4162 14.8083 16.8495L13.3667 17.6745C12.7083 18.0662 11.8583 17.8329 11.4667 17.1745L11.375 17.0162C10.625 15.7079 9.39167 15.7079 8.63333 17.0162L8.54167 17.1745C8.15 17.8329 7.3 18.0662 6.64167 17.6745L5.2 16.8495C4.44167 16.4162 4.18333 15.4412 4.61667 14.6912C5.375 13.3829 4.75833 12.3162 3.25 12.3162C2.375 12.3162 1.66667 11.5995 1.66667 10.7329Z",
    stroke: "#00A79D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenance);
export default __webpack_public_path__ + "static/media/maintenance.032cd43205dbbc5d25a2e8c9e3b73e11.svg";
export { ForwardRef as ReactComponent };